import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { ACTIVITY_FEATURE_GROUP } from './group';

export const ACTIVITY_FEATURES = {
  READ: {
    guid: '939d0281-5204-4d6d-8eee-866f97b00001',
    name: 'activity:read',
    description: 'View the account activity log',
    action: 'read',
    product: 'account',
    parentGuid: ACTIVITY_FEATURE_GROUP.guid,
  },
  EXPORT: {
    guid: '939d0281-5204-4d6d-8eee-866f97b00011',
    name: 'activity:export',
    description: 'Export account activity log entries',
    action: 'read',
    product: 'account',
    parentGuid: ACTIVITY_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { ACTIVITY_FEATURE_GROUP } from './group';

export const ACTIVITY_MODULE: FeatureModule = {
  product: 'account',
  groups: [ACTIVITY_FEATURE_GROUP],
  features: featureList(ACTIVITY_FEATURES),
};
